<template>
  <div>
    <nav class="navbar is-link">
      <div class="navbar-brand ">
        <div class="navbar-burger burger is-link"
             onclick="document.querySelector('.navbar-menu').classList.toggle('is-active')"
             data-target="navbarExampleTransparentExample">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="navbarExampleTransparentExample" class="navbar-menu">
        <div class="navbar-start">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link" href="/">
              Titre 1
            </a>
            <div class="navbar-dropdown">
              <a class="navbar-item is-hoverable" href="">
                Soustitre 1
              </a>
              <a class="navbar-item" href="">
                Soustitre 2
              </a>
              <a class="navbar-item" href="">
                Soustitre 3
              </a>
              <a class="navbar-item" href="">
                Soustitre 4
              </a>
              <a class="navbar-item" href="">
                Soustitre 5
              </a>
            </div>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link" href="/">
              Titre 2
            </a>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link" href="/">
              Titre 3
            </a>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link" href="/">
              Titre 4
            </a>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link" href="/">
              Titre 5
            </a>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link" href="/">
              Titre 6
            </a>
          </div>
        </div>
      </div>
    </nav>
    <div class="columns">
      <div class="column">
        <div class="message">{{ message }}</div>
        <div class="section">
          <p>Bouton</p>
          <div class="container-fluid">
            <a class="button is-primary ">Primary</a>
            <a class="button is-success ">Success</a>
            <a class="button is-warning ">Warning</a>
            <a class="button is-danger ">Danger</a>
          </div>
          <br>
          <div class="container-fluid">
            <a class="button is-primary is-outlined" >Primary</a>
            <a class="button is-success is-outlined">Success</a>
            <a class="button is-warning is-outlined">Warning</a>
            <a class="button is-danger is-outlined">Danger</a>
          </div>
          <br>
          <div class="container-fluid">
            <b-field>
              <b-checkbox-button v-model="checkboxGroup"
                                 native-value="Primary"
                                 type="is-primary">
                <span>Primary</span>
              </b-checkbox-button>
              <b-checkbox-button v-model="checkboxGroup"
                                 native-value="Success"
                                 type="is-success">
                <span>Success</span>
              </b-checkbox-button>
              <b-checkbox-button v-model="checkboxGroup"
                                 native-value="Warning"
                                 type="is-warning">
                <span>Warning</span>
              </b-checkbox-button>
              <b-checkbox-button v-model="checkboxGroup"
                                 native-value="Danger"
                                 type="is-danger">
                <span>Danger</span>
              </b-checkbox-button>
            </b-field>
            <p class="content">
              <b>Selection:</b>
              {{ checkboxGroup }}
            </p>
          </div>
          <br>
          <div class="container-fluid">
            <p>Tags / Fitre</p>
            <span class="tag">
          Link
        </span>
          </div>
          <br>
          <div class="container-fluid">
            <p>Dropdowns</p>
            <b-dropdown>
              <button class="button is-primary" slot="trigger">
                <span>Click me!</span>
                <b-icon icon="menu-down"></b-icon>
              </button>

              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else</b-dropdown-item>
            </b-dropdown>
            <b-dropdown>
              <button class="button is-primary is-outlined" slot="trigger">
                <span>Click me!</span>
                <b-icon icon="menu-down"></b-icon>
              </button>
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else</b-dropdown-item>
            </b-dropdown>
          </div>
          <br>
          <div class="container-fluid">
            <p>Radios bouton</p>
            <b-field>
              <b-radio-button v-model="radioButton"
                              native-value="Option 1"
                              type="is-select">
                <span class="has-text-default">Option 1</span>
              </b-radio-button>

              <b-radio-button v-model="radioButton"
                              native-value="Option 2"
                              type="is-select">
                <span class="has-text-default">Option 2</span>
              </b-radio-button>

              <b-radio-button v-model="radioButton"
                              native-value="Option 3"
                              type="is-select">
                <span class="has-text-default">Option 3</span>
              </b-radio-button>

            </b-field>
            <p class="content">
              <b>Selection:</b>
              {{ radioButton }}
            </p>
          </div>
          <br>
          <div class="container-fluid">
            <p>Radios bouton 2</p>
            <div class="block">
              <b-radio v-model="radio"
                       native-value="Option 1">
                <span class="has-text-default">Option 1</span>
              </b-radio>
              <b-radio v-model="radio"
                       native-value="Option 2">
                <span class="has-text-default">Option 2</span>
              </b-radio>
              <b-radio v-model="radio"
                       native-value="Option 3">
                <span class="has-text-default">Option 3</span>
              </b-radio>
            </div>
            <p class="content">
              <b>Selection:</b>
              {{ radio }}
            </p>
          </div>
          <br>
          <div class="container-fluid">
            <p>Pagination</p>
            <b-pagination
              :total="total"
              v-model="current"
              :order="order"
              :size="size"
              :simple="isSimple"
              :per-page="perPage">
            </b-pagination>
          </div>
          <br>
          <div class="container-fluid">
            <p>Switch</p>
            <div class="field">
              <b-switch v-model="isSwitchedCustom" type="is-primary" true-value="Yes"
                        false-value="No">
                {{ isSwitchedCustom }}
              </b-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="section">
          <div class="container-fluid">
            <b-field label="Label">
              <b-input placeholder="Label" v-model="name"></b-input>
            </b-field>
            <b-field label="Success" type="is-success">
              <b-input placeholder="Success"></b-input>
            </b-field>

            <b-field label="Error"
                     type="is-danger"
                     message="Erreur de saisie">
              <b-input placeholder="Error"></b-input>
            </b-field>

            <b-field label="Warning" type="is-warning"
                     message="Warning">
              <b-input placeholder="Warning"></b-input>
            </b-field>
          </div>
          <br>
          <div class="container-fluid">
            <p>Impage upload</p>
            <b-field>
              <b-upload v-model="dropFiles"
                        multiple
                        drag-drop>
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon
                        icon="upload"
                        size="is-large">
                      </b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <b-field>
              <b-upload v-model="files">
                <a class="button is-primary">
                  <b-icon icon="upload"></b-icon>
                  <span>Click to upload</span>
                </a>
              </b-upload>
              <div v-if="files && files.length">
              <span class="file-name">
                  {{ files[0].name }}
              </span>
              </div>
            </b-field>
            <div class="tags">
              <span v-for="(file, index) in dropFiles"
                    :key="index"
                    class="tag is-primary" >
                  {{file.name}}
                  <button class="delete is-small"
                          type="button"
                          @click="deleteDropFile(index)">
                  </button>
              </span>
            </div>
          </div>
          <br>
          <div class="container-fluid">
            <p>Checkbox</p>
            <div class="block">
              <b-checkbox v-model="checkboxGroup"
                          native-value="Option 1">
                Option 1
              </b-checkbox>
              <b-checkbox v-model="checkboxGroup"
                          native-value="Option 2">
                Option 2
              </b-checkbox>
              <b-checkbox v-model="checkboxGroup"
                          native-value="Option 3">
                Option 3
              </b-checkbox>
            </div>
            <p class="content">
              <b>Selection:</b>
              {{ checkboxGroup }}
            </p>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="section">
          <div class="container-fluid">
            <p>Dropdown input</p>
            <b-field label="Label (Radio)">
              <b-select placeholder="Select" v-model="optionSelect">
                <option
                  v-for="option in options"
                  :value="option"
                  :key="option">
                  {{ option }}
                </option>
              </b-select>
            </b-field>
            Option sélectionnée : {{optionSelect}}
          </div>
          <br>
          <div class="container-fluid">
            <p>Date Picker</p>
            <div class="level">
              <div class="level-left">
                <b-field label="Select a date">
                  <b-datepicker
                    placeholder="Click to select..."
                    icon="calendar-today">
                  </b-datepicker>
                </b-field>
              </div>
            </div>
          </div>
          <br>
          <div class="container-fluid">
            <p>Tag</p>
            <div class="level">
              <div class="level-left">
                <b-field label="Info">
                </b-field>
              </div>
            </div>
          </div>
          <br>
          <div class="container-fluid">
            <p> Info Bulle</p>
            <b-tooltip
              label="Tooltip multilined, probably because it's too long for a casual tooltip"
              multilined>
              <button class="button is-dark">
                Multiline (default)
              </button>
            </b-tooltip>
          </div>
          <br>
          <div class="container-fluid">
            <p class="subtitle is-6">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at.
              Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.
            </p>
          </div>
          <br>
          <div class="container-fluid">
            <b-tabs type="is-toggle">
              <b-tab-item label="Liste" icon="format-list-bulleted"></b-tab-item>
              <b-tab-item label="Carte" icon="google-maps"></b-tab-item>
              <b-tab-item label="Planning" icon="timetable"></b-tab-item>
            </b-tabs>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="section">
          <div class="container-fluid">
            <h1 class="title is-1">Title 1</h1>
            <h2 class="title is-2">Title 2</h2>
            <h3 class="title is-3">Title 3</h3>
            <h4 class="title is-4">Title 4</h4>
            <h5 class="title is-5">Title 5</h5>
            <h6 class="title is-6">Title 6</h6>
            <h1 class="subtitle is-1">Subtitle 1</h1>
            <h2 class="subtitle is-2">Subtitle 2</h2>
            <h3 class="subtitle is-3">Subtitle 3</h3>
            <h4 class="subtitle is-4">Subtitle 4</h4>
            <h5 class="subtitle is-5">Subtitle 5</h5>
            <h6 class="subtitle is-6">Subtitle 6</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      message: 'Welcome',
      radioButton: '',
      radio: '',
      total: 200,
      current: 1,
      perPage: 20,
      order: '',
      size: '',
      isSimple: false,
      isSwitchedCustom: 'Yes',
      dropFiles: [],
      checkboxGroup: [],
      options: ['Matériel', 'Format', 'Zone géographique'],
      optionSelect: '',
      name: '',
      files: [],
      tags: [],
      panels: [
        {
          id: 1,
          codeFace: '2280',
          format: '25',
          materiel: 'Monroe',
          address: '860 Malbone Street',
          codePostal: '8116',
          city: 'Garnet',
          latitude: '-56.675149',
          longitude: '94.720171',
        },
        {
          id: 2,
          codeFace: '2557',
          format: '18',
          materiel: 'Young',
          address: '703 Woodruff Avenue',
          codePostal: '2872',
          city: 'Santel',
          latitude: '-49.051632',
          longitude: '71.284471',
        },
        {
          id: 3,
          codeFace: '2397',
          format: '26',
          materiel: 'York',
          address: '394 Liberty Avenue',
          codePostal: '5572',
          city: 'Blende',
          latitude: '76.449478',
          longitude: '103.312455',
        },
        {
          id: 4,
          codeFace: '3349',
          format: '14',
          materiel: 'Park',
          address: '640 Heyward Street',
          codePostal: '6675',
          city: 'Brethren',
          latitude: '-51.53247',
          longitude: '78.023561',
        },
        {
          id: 5,
          codeFace: '3992',
          format: '17',
          materiel: 'Ellen',
          address: '972 Kings Hwy',
          codePostal: '9750',
          city: 'Grantville',
          latitude: '62.118748',
          longitude: '159.05486',
        },
        {
          id: 6,
          codeFace: '3861',
          format: '29',
          materiel: 'Meyer',
          address: '756 Hawthorne Street',
          codePostal: '1082',
          city: 'Roderfield',
          latitude: '-78.924221',
          longitude: '46.241486',
        },
        {
          id: 7,
          codeFace: '3664',
          format: '23',
          materiel: 'Marina',
          address: '710 Rutland Road',
          codePostal: '6907',
          city: 'Irwin',
          latitude: '27.117782',
          longitude: '102.382461',
        },
        {
          id: 8,
          codeFace: '2636',
          format: '29',
          materiel: 'Patrice',
          address: '854 Jamaica Avenue',
          codePostal: '3196',
          city: 'Statenville',
          latitude: '7.049103',
          longitude: '-145.241948',
        },
        {
          id: 9,
          codeFace: '3686',
          format: '15',
          materiel: 'Wooten',
          address: '758 Caton Avenue',
          codePostal: '8372',
          city: 'Williams',
          latitude: '13.741697',
          longitude: '100.28401',
        },
        {
          id: 10,
          codeFace: '3198',
          format: '29',
          materiel: 'Brennan',
          address: '227 Amber Street',
          codePostal: '1327',
          city: 'Dixie',
          latitude: '43.741306',
          longitude: '-117.440474',
        },
        {
          id: 11,
          codeFace: '3326',
          format: '24',
          materiel: 'Deana',
          address: '811 McDonald Avenue',
          codePostal: '6185',
          city: 'Waiohinu',
          latitude: '7.512917',
          longitude: '66.476054',
        },
        {
          id: 12,
          codeFace: '2414',
          format: '11',
          materiel: 'Poole',
          address: '140 Kenmore Court',
          codePostal: '2073',
          city: 'Caroleen',
          latitude: '58.107129',
          longitude: '122.683389',
        },
        {
          id: 13,
          codeFace: '2567',
          format: '25',
          materiel: 'Smith',
          address: '106 Eastern Parkway',
          codePostal: '1836',
          city: 'Osage',
          latitude: '-1.463683',
          longitude: '147.722598',
        },
        {
          id: 14,
          codeFace: '2628',
          format: '25',
          materiel: 'Dolores',
          address: '783 Landis Court',
          codePostal: '3062',
          city: 'Katonah',
          latitude: '84.184917',
          longitude: '-11.861307',
        },
        {
          id: 15,
          codeFace: '2232',
          format: '29',
          materiel: 'Macias',
          address: '843 Wallabout Street',
          codePostal: '2273',
          city: 'Maybell',
          latitude: '-7.245217',
          longitude: '134.698589',
        },
        {
          id: 16,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
        {
          id: 17,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
        {
          id: 18,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
        {
          id: 19,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
        {
          id: 20,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
        {
          id: 21,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
        {
          id: 22,
          codeFace: '3657',
          format: '29',
          materiel: 'Mercedes',
          address: '469 Conway Street',
          codePostal: '8930',
          city: 'Wilmington',
          latitude: '-80.70072',
          longitude: '116.681691',
        },
      ],
      selected: [],
    };
  },
  computed: {
  },
  methods: {
    deleteDropFile: function DeleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/demoComposants/demoComposants.vue